<template>
    <div class="container-header">
        <div class="box-header-path">
            <div class="text-header-path">{{ $route.meta.title }}</div>
        </div>
        <div class="box-logout-time">자동 로그아웃 <span>{{ leaveTimer }}</span></div>
        <div class="profile-box ml16">
            <div class="profile-nickName">{{ UserInfo.mbName }}<span>님, 환영합니다.</span></div>
        </div>
        <button class="btn-logout" @click="logout()"></button>
    </div>
    <change-pwd-modal></change-pwd-modal>
    <update-temp-pwd-modal></update-temp-pwd-modal>
</template>

<script>
import Swal from "sweetalert2";
import alertMixins from "@/mixins/alertMixins";
import {mapState} from "vuex";
import dateMixins from "@/mixins/dateMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import {setAuthInHeader} from "@/api/request";
import axios from "axios";
import {apiJavaURL} from "@/api/config";
import moment from "moment/moment";
import router from "@/router";
import AuthMixins from "@/mixins/AuthMixins";
import {getStorageToken, logout} from "@/mixins/Auth";
import log from "@/mixins/logMixins";
import ChangePwdModal from "@/components/modal/ChangePwdModal.vue";
import UpdateTempPwdModal from "@/components/modal/UpdateTempPwdModal.vue";

let timeInterval = null;

export default {
    name: "PageHeader",
    mixins: [alertMixins, dateMixins, AuthMixins, log],
    components: {ChangePwdModal, UpdateTempPwdModal},
    props: {},
    data() {
        return {
            collapsedStatus: true,
            leaveTimer: '00 : 00 : 00',
            diff: 7200,
            menuItem: [],
            input: '',
            diffCont: {
                creator: 7200,
                member: 1800,
                manage: 1800,
                admin: 1800,
                default: 1800,
            },
            adminType: '',
            callingToken: false,
            passwordModalOpened: false,
        }
    },
    created() {
        this.adminType = this.getAdminType();
        this.diff = this.getInitDiffDate();
    },
    mounted() {
        EventBus.$on('resetLogoutTimer', this.reduceUseSecond)
        EventBus.$on('onToggleCollapse', this.onToggleCollapse)
        this.getToken()
        timeInterval = setInterval(this.reduceUseSecond, 1000);
        this.makeMenuMemberType()
    },
    beforeUnmount() {
        EventBus.$off('resetLogoutTimer')
        clearInterval(timeInterval)
    },
    unmounted() {
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    methods: {
        crmLog(type) {
            let params = {
                depth: 1,
                access: '로그인/로그아웃'
            }
            return this.log(params, type, this.UserInfo.mb_no)
        },
        logout() {
            Swal.fire({
                title: '로그아웃',
                text: '로그아웃 하시겠습니까?',
                confirmButtonText: "확인",
                cancelButtonText: "취소",
                showCancelButton: true,
                customClass: 'admin_default confirm logout',
            }).then(async (result) => {
                if (result.value) {
                    try {
                        await this.crmLog('로그아웃');
                        await this.$api.$auth.logout();
                    } finally {
                        this.$localStorage.remove('useTime');
                        this.$localStorage.remove('token');
                        this.$localStorage.remove('level');
                        location.href = '/auth';
                    }
                }
            });
        },

        movePage(url) {
            let currentUrl = this.$route.path
            if (url !== currentUrl) {
                this.$router.push(url)
            }
        },
        makeMenuMemberType() {
            if (this.UserInfo.hasOwnProperty('g_type') && this.UserInfo.g_type === 'creator') { // 생성자
                this.menu = this.makerMenu
            } else {
                this.menu = this.menu
            }
        },
        handleActive() {
            let path = this.$route.path
            return path
        },
        openModal(name) {
            this.$vfm.show(name)
        },
        async autoLogoutAlert() {
            try {
                await this.crmLog('로그아웃');
                await this.$api.$auth.logout();
            } catch (e) {
                console.log(e);
            }
            let text = '개인정보 보호를 위해<br>로그인 후 30분동안 사용내역이 없어 로그아웃 처리되었습니다.<br>접속하시려면 다시 로그인하세요.'
            if (this.getAdminType() === 'creator') {
                text = '개인정보 보호를 위해<br>로그인 후 2시간동안 사용내역이 없어 로그아웃 처리되었습니다.<br>접속하시려면 다시 로그인하세요.'
            }
            this.createAlert({
                title: '자동 로그아웃되었습니다.',
                content: text,
                confirmText: '확인',
                hide: () => {

                    this.$localStorage.remove('useTime');
                    this.$localStorage.remove('token');
                    location.href = '/auth';
                }
            })
        },
        async blockLogoutAlert() {
            try {
                await this.crmLog('로그아웃');
                await this.$api.$auth.logout();
            } catch (e) {
                console.log(e);
            }
            let text = '계정 정지로 인해 자동 로그아웃되었습니다.<br>슈퍼관리자에게 문의하세요.'
            this.createAlert({
                title: '자동 로그아웃되었습니다.',
                content: text,
                confirmText: '확인',
                hide: () => {

                    this.$localStorage.remove('useTime');
                    this.$localStorage.remove('token');
                    location.href = '/auth';
                }
            })
        },
        getInitDiffDate() {
            if (this.diffCont.hasOwnProperty(this.adminType)) {
                return this.diffCont[this.adminType]
            }
            return this.diffCont.default;
        },
        reduceUseSecond(reset = false) {
            if (reset) {
                this.getToken()
                this.diff = this.getInitDiffDate();
            }

            let lastUseTime = this.$moment(this.$localStorage.get('useTime')); // 최근 사용 시간
            let now = this.$moment()/*.add(30, 'minutes')*/ // 현재에서 120분뒤

            let afterTen = this.$moment(this.returnDateFormat(now, 'YYYY-MM-DD HH:mm:ss')) // 포매팅

            let localDiff = (this.$moment.duration(afterTen.diff(lastUseTime)).asSeconds())
            this.diff = this.getInitDiffDate() - localDiff;
            if (isNaN(this.diff) || this.diff <= 0) { // 종료시 로그아웃 띄움
                clearInterval(timeInterval)
                this.diff = this.getInitDiffDate();
                this.leaveTimer = '00:00:00';
                this.autoLogoutAlert();
                return
            }

            let hour = parseInt(this.diff / 3600, 10)
            let min = parseInt((this.diff % 3600) / 60, 10)
            let sec = parseInt((this.diff % 3600) % 60, 10)

            hour = hour < 10 ? `0${hour}` : hour
            min = min < 10 ? `0${min}` : min
            sec = sec < 10 ? `0${sec}` : sec

            this.leaveTimer = `${hour} : ${min} : ${sec}`
        },
        onItemClick(event, item, node) {
            if (!item.hasOwnProperty('child') || util.isEmpty(item.child)) {
                this.collapsedStatus = true;
            }
        },
        onToggleCollapse(collapsed) {
            this.collapsedStatus = collapsed
        },
        getToken(type = true) {
            if (this.callingToken) return;
            this.callingToken = true;
            let token = getStorageToken();
            if (!token) {
                return;
            }
            setAuthInHeader(token);
            return axios.get(`${apiJavaURL + 'v1/admin/jwt/CMS'}`,).then(res => {
                    this.callingToken = false;
                    if (res.data.code === 1) {
                        let token = res.data.result.data
                        this.$localStorage.set('token', token);
                        setAuthInHeader(token);
                    } else {
                        if (type) {
                            this.getToken(false);
                        }
                    }
                    return res;
                }).catch(({response}) => {
                    this.callingToken = false;
                    router.push('/auth')
                    const {status} = response;
                    if (status === 400 || status === 401 || status === 500) {
                        logout();
                    } else if (status === Errored) {
                        alert("잘못된 정보입니다.")
                    }
                    throw Error(response)
                })
        },
        checkPassword() {
            let updateDate = this.UserInfo.mbPasswordUpdatedDate;
            if (!updateDate) {
                return;
            }
            let current = this.$date();
            let end = this.$date(updateDate)
            let endDate = current.diff(end, 'day');
            if (endDate > 90) {
                this.$vfm.show('change-pwd-modal');
            }
        },
        isTempPasswordUser() {
            return Number(this.UserInfo.isTempPassword ?? this.UserInfo.is_temp_password ?? 0) === 1;
        },
        showTempPasswordIssuedAlert() {
            this.createAlert({
                title: '임시 비밀번호 발급 안내',
                content: '임시 비밀번호가 발급 되었습니다.<br>자동 로그아웃 처리되며 다시 로그인 후 비밀번호를 변경해주세요.',
                btnText: '닫기',
                hide: () => {
                    logout(this);
                }
            });
        },
        checkPasswordPolicy() {
            if (util.isEmpty(this.UserInfo)) {
                return;
            }

            this.$nextTick(() => {
                const isTempPasswordUser = this.isTempPasswordUser();
                const updateDate = this.UserInfo.mbPasswordUpdatedDate;
                let isExpiredPassword = false;

                if (updateDate) {
                    let current = this.$date();
                    let end = this.$date(updateDate);
                    let endDate = current.diff(end, 'day');
                    isExpiredPassword = endDate > 90;
                }

                if (!isTempPasswordUser && !isExpiredPassword) {
                    this.passwordModalOpened = false;
                    return;
                }

                if (this.passwordModalOpened) {
                    return;
                }

                if (isTempPasswordUser) {
                    this.passwordModalOpened = true;
                    if (this.$route.path === '/auth') {
                        this.$vfm.show('update-temp-pwd-modal');
                    } else {
                        this.showTempPasswordIssuedAlert();
                    }
                    return;
                }

                if (isExpiredPassword) {
                    this.passwordModalOpened = true;
                    this.$vfm.show('change-pwd-modal');
                }
            });
        }
    },
    watch: {
        'UserInfo': {
            deep: true,
            immediate: true,
            handler: function (val, oldVal) {
                if (val.mbStatus === 0) {
                    this.blockLogoutAlert();
                }
                if (util.isEmpty(val)) {
                    let token = this.$localStorage.get('token');
                    this.$store.dispatch('userInfo/setUserInfo', {token: token});
                    this.passwordModalOpened = false;
                    return;
                }
                this.checkPasswordPolicy();
            }
        },
        '$route.path': {
            deep: true,
            handler: function (val, oldVal) {
                $(document).ready(function () {
                    $('#main_content').click(function () {
                        EventBus.$emit('onToggleCollapse', true)
                    });
                });

                if (oldVal !== val) {
                    let token = getStorageToken();
                    this.$store.dispatch('userInfo/setUserInfo', {token: token});
                }
            }
        }
    },
}
</script>

<style lang="scss">
</style>
